import React, { Component, useState, useMemo, useEffect } from 'react';
import { RelevantIcon, reversibleHash, setCookie, getResultFromCondition, getValueFromCondition, replaceVariablesWithValue, handleLink } from '../oro-module/commonFunctions';
import { MdOpenInNew } from "react-icons/md";
import { fetchData } from '../common/networkRequests';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { handlePageChange } from '../oro-module/ajaxdata';
import moment from "moment";
import requiredFields from '../oro-module/requiredFields';
import LoadingIndicator from "../../../src/images/loading_capsule.gif"
import NoData from "../../../src/images/nodata.png";

const WidgetSearchBox = ({ searched, setsearched }) => {
  return (
    <div className="widget-search-box"><input placeholder='search . . .' className="widget-search-input" value={searched} onChange={(e) => setsearched(e.target.value)} /></div>
  )
}


const ConvertedKPIValue = ({ style = {}, value }) => {
  let color = "black";
  var dateRegExp = /[0-9]{4}-[0-9]{2}-[0-9]{2} /g;
  if (value && String(value).indexOf('icon-') != -1) {
    if (value == 'icon-tick') {
      style['color'] = "#6de26d";
    }
    else if (value == 'icon-cross') {
      style['color'] = "white";
    } else {
      style['color'] = color;
    }
    return <span className="listvalue" style={style}><RelevantIcon icon={value.replace("icon-", "")} /></span>;
  } else if (value && String(value).match(dateRegExp) && value.match(dateRegExp).length > 0) {
    let dateago = moment(value.replace(".000Z", "")).fromNow();
    return <span className="listvalue" style={style}>{dateago}</span>
  } else {
    return <span className="listvalue" style={style}>{value}</span>
  }
}

const FollowupListRow = ({ label, value, current, islast }) => {
  // console.log({ label, value })
  let url = label.url;
  if (label.url_id) {
    url += "/" + label.url_id;
  }
  if (label.url_id2) {
    url += "/" + label.url_id2;
  }
  if (label.url_id3) {
    url += "/" + label.url_id3;
  }

  let valueStyle = {};
  if (value.backgroundColor) {
    valueStyle["backgroundColor"] = value.backgroundColor;
  }
  if (value.fontSize) {
    valueStyle["fontSize"] = value.fontSize;
  }
  if (value.font) {
    valueStyle["fontFamily"] = value.font;
  }
  return (
    <div className="row"
      style={{ marginTop: 4, marginBottom: 3, paddingLeft: 5 }}
    >
      <div className={`${label.url ? 'url-kpi' : 'not-url-kpi'} ${label.width ? 'col-sm-' + label.width : "col-sm-6"} sub-title`}>

        <span className={`${label.is_clickable ? 'hand kpi-link' : ''} `} onClick={() => label.is_clickable ? handleLink({ url, new_tab: label.open_in_new, current }) : false} >
          {label.title}
        </span>
      </div>

      <div className={`${value.width ? 'col-sm-' + value.width : "col-sm-6"} action right`}
      // onMouseEnter={() => setMessage(message)} onMouseLeave={() => removeMessage(message)} 
      >
        <ConvertedKPIValue style={valueStyle} value={value.title} />
      </div>

      {!islast &&
        <div className="col-sm-12"><hr style={{ margin: 0 }}></hr></div>
      }
    </div>
  );
}

const ListWidget = (props) => {
  let { values, showvalues, dformat, clickable, emptymsg, reportName, query_group, format } = props.component;
  let { label, value } = format;
  let { selectedTourBranch } = props.parentState.LocalVars;

  let [dashboarddata, setdashboarddata] = useState([]);
  let [alldashboarddata, setalldashboarddata] = useState([]);

  let [emptymessage, setemptymessage] = useState(emptymsg ? emptymsg : "No Data");
  let [loading, setloading] = useState(false);

  let [searched, setsearched] = useState("");


  let defaultFontFamily = "arial";
  let defaultFontSize = 16;



  const setDashData = (alldata) => {
    let widgetData = [];
    if (alldata.error) {
      setemptymessage(alldata.error);
    } else {
      for (var i = 0; i < alldata.results.length; i++) {
        let row = alldata.results[i];
        let converted = {};
        let labelData = {};
        let valueData = {};

        labelData["title"] = getResultFromCondition(label.display_field, row);
        // labelData["title"] = row[label.display_field].substr(0, label.truncate_after ? label.truncate_after : 50);

        let truncate = label.truncate_after ? label.truncate_after : 60;
        labelData["title"] = labelData["title"] ? labelData["title"].substr(0, truncate) + (labelData["title"].length > truncate ? "..." : "") : "";

        labelData["is_clickable"] = false;
        let resclickable = getResultFromCondition(label.clickable_condition, row);
        if (resclickable) {
          labelData["is_clickable"] = resclickable;
        }

        labelData["url"] = row[label.url_field];
        labelData["url_id"] = label.url_value_field ? row[label.url_value_field] : false;
        labelData["url_id2"] = label.url_value_field_2 ? row[label.url_value_field_2] : false;
        labelData["url_id3"] = row['ff_identi'] ? row['ff_identi'] : false;


        labelData["open_in_new"] = label.is_open_in_new;
        labelData["full_title"] = getResultFromCondition(label.display_field, row); // row[label.display_field];
        labelData["width"] = label.width;
        labelData["font"] = row[label.font] ? row[label.font] : defaultFontFamily;
        labelData["font_size"] = row[label.font_size] ? row[label.font_size] : defaultFontSize;

        valueData["width"] = value.width;
        valueData["font"] = row[value.font] ? row[value.font] : defaultFontFamily;
        valueData["font_size"] = row[value.font_size] ? row[value.font_size] : defaultFontSize;

        let restitle = getResultFromCondition(value.display_field, row);
        valueData['title'] = restitle;
        valueData["backgroundColor"] = value.background_color;
        let rescol = getResultFromCondition(value.background_color_condition, row);
        if (rescol) {
          valueData["backgroundColor"] = rescol;
        }
        converted.label = labelData;
        converted.value = valueData;
        widgetData.push(converted);
      }
      setdashboarddata(widgetData);
      setalldashboarddata(widgetData);
    }

    setloading(false);
  }

  const getLatestData = (selectedTourBranch) => {
    let method = 'post';
    let pd = { gui: "dashboard" };
    if (selectedTourBranch) {
      pd['branch_uid'] = selectedTourBranch.value;
      if (selectedTourBranch.more_1) {
        pd['more_1'] = selectedTourBranch.more_1;
      }
    }
    if (query_group) {
      pd['query_group'] = query_group;
    }
    let saveThis = { dataType: "search", pageData: pd, currentPage: reportName };
    if (reportName || query_group) {
      setloading(true);
      fetchData({ url: 'cbsurl', postData: saveThis, method, current: { props }, cbf: setDashData });
    }
  }

  const filterData = () => {
    if (searched.length > 0) {
      let newdata = [];
      for (var i = 0; i < alldashboarddata.length; i++) {
        let row = alldashboarddata[i];
        let matched = false;
        if (String(row.label.title).toLowerCase().indexOf(searched.toLowerCase()) != -1) {
          matched = true;
        }
        else if (String(row.value.title).toLowerCase().indexOf(searched.toLowerCase()) != -1) {
          matched = true;
        }
        if (matched) {
          newdata.push(row);
        }
      }
      setdashboarddata(newdata);
    } else if (searched.length == 0) {
      setdashboarddata(alldashboarddata);
    }
  }

  useMemo(() => getLatestData(selectedTourBranch), [selectedTourBranch]);

  useMemo(() => filterData(), [searched]);




  let hasclickable = false;

  const WidgetData = ({ dashboarddata }) => {
    return (
      <div>
        {!loading &&
          dashboarddata.map(({ label, value }, idx) => {
            return (
              <div key={idx} className="fl-rec">
                <FollowupListRow label={label} value={value} current={{ props }} islast={dashboarddata.length - 1 == idx} />
              </div>
            )
          })
        }

        {!loading && dashboarddata.length == 0 &&
          <div className="empty-message">
            <RelevantIcon icon="exclaim-circle" />&nbsp;{emptymessage}
          </div>
        }
      </div>
    )
  }


  return (
    <div
      className={`form-group nopadding  ${props.component.widths.parent}`}
    >
      <div className="kpilist-container">
        {loading &&
          <div className="empty-message"><img style={{ height: 40 }} src={LoadingIndicator} /></div>
          // <Skeleton count={5} />
        }
        <WidgetData dashboarddata={dashboarddata} />
      </div>

      <WidgetSearchBox searched={searched} setsearched={setsearched} />
    </div>
  )
}

export default ListWidget;